// Typed easing constants for framer-motion animations
// These prevent TypeScript errors when passing number[] arrays as ease property

export const EASE_OUT = [0.22, 1, 0.36, 1] as const;
export const EASE_CUSTOM = [0.16, 1, 0.3, 1] as const;
export const EASE_IN_OUT = [0.43, 0.13, 0.23, 0.96] as const;
export const EASE_IN = [0.42, 0, 1, 1] as const;
export const EASE_CUBIC = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_QUAD = [0.455, 0.03, 0.515, 0.955] as const;
